export const authRoles = {
    admin: ['Admin'], // Only Admin has access
    user: ['Admin', 'User'], // Only Admin & User has access
}
